/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationStoreInAppOneStoreOneStoreInAppBillingData, FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingDataFromJSONTyped, FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingDataToJSON, } from './FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingData';
export function FxIdApplicationStoreInAppInAppValidationRequestOneStoreInAppBillingDataFromJSON(json) {
    return FxIdApplicationStoreInAppInAppValidationRequestOneStoreInAppBillingDataFromJSONTyped(json, false);
}
export function FxIdApplicationStoreInAppInAppValidationRequestOneStoreInAppBillingDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationStoreInAppOneStoreOneStoreInAppBillingData(json)) {
        return FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingDataFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationStoreInAppInAppValidationRequestOneStoreInAppBillingDataToJSON(json) {
    return FxIdApplicationStoreInAppInAppValidationRequestOneStoreInAppBillingDataToJSONTyped(json, false);
}
export function FxIdApplicationStoreInAppInAppValidationRequestOneStoreInAppBillingDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationStoreInAppOneStoreOneStoreInAppBillingData(value)) {
        return FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingDataToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationStoreInAppInAppValidationRequestOneStoreInAppBillingData.js.map